module.exports = __webpack_public_path__ + "img/rule-content-zh.60170b86.png";